<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 pt-5>
        <v-alert :value="true" v-if="error != null" type="error">{{
          error.message
        }}</v-alert>
        <v-alert :value="true" v-if="success != null" type="success">{{
          success.message
        }}</v-alert>

        <v-layout justify-center column>
          <v-layout row v-if="client_ref_no">
            <v-flex xs12 pt-0 pb-4>
              <p class="notice">
                Your account is currently linked to the Fan ID
                <strong>{{ client_ref_no }}</strong
                >.
              </p>
              <p class="notice">
                If this is not your Fan ID then please
                <a href="https://tickets.avfc.co.uk/crmdetails.aspx"
                  >click here</a
                >
                to unlink your account from this Fan ID.
              </p>
            </v-flex>
          </v-layout>

          <v-layout row v-else>
            <v-flex xs12 pt-0 pb-4 v-if="showIframe">
              <p class="notice">
                {{ given_name }} please link your account to the ticketing
                system using the form below.
              </p>
              <!--
              <button v-on:click="loadIframe">Reload iframe</button>
              <button v-on:click="getUpdatedDetails">Refresh details</button>
              -->
            </v-flex>
          </v-layout>

          <v-layout row v-show="showIframe">
            <v-flex>
              <iframe
                v-if="renderIframe"
                frameborder="0"
                scrolling="no"
                style="border: 0px"
                id="ticketingIFrame"
                src=""
                width="100%"
                height="1200"
              ></iframe>
            </v-flex>
          </v-layout>

          <v-layout row v-show="showLoadingBar">
            <v-flex xs6 sm8 offset-sm2 pt-5>
              <p class="notice">Linking your accounts, please wait...</p>
              <progress id="loadBar"></progress>
            </v-flex>
          </v-layout>

          <v-layout row v-show="showLoadingBar">
            <v-flex xs6 sm8 offset-sm2 pt-5>
              <ul class="features">
                <li
                  id="iconToShow"
                  class="features__item features__item--sso-app"
                >
                  App
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "UserProfileSeatgeekLink",
  components: {},
  data() {
    return {
      valid: true,
      error: null,
      success: null,
      loading: false,
      client_ref_verified: null,
      client_ref_no: null,
      given_name: null,
      showIframe: false,
      renderIframe: true,
      showLoadingBar: false,
      linkInProgress: false,
      loadingBarSeconds: 5,
      cbval: "",
      color: "#73a2dc",
      size: "45px",
      iconloading: true,
      loadingIconArray: [
        { icon: "sso-app", title: "App" },
        { icon: "sso-ticketing", title: "Ticketing" },
        { icon: "sso-auction-site", title: "Auction Site" },
        { icon: "sso-club-site", title: "Club Site" },
        { icon: "sso-rewards", title: "Rewards" },
        { icon: "sso-memberships", title: "Memberships" },
        { icon: "villatv", title: "VillaTV" },
      ],
    };
  },
  mounted() {
    this.getUpdatedDetails();
    var vm = this;

    /*
    Flow once we detect a link has been made (by detecting the error page in the iframe)
    - hide the iframe from display
    - trigger a reload of the iframe (not the whole page)
    - wait a couple of seconds
    - reload the user data from AWS (silently in the background)
    - refresh all tokens
    */

    //wait for iframe to redirect to error page
    window.addEventListener(
      "message",
      (e) => {
        if (e.isTrusted === true) {
          // Allow trusted domain origins only, also frame-anscestors headers must be set in cloudfront
          if (
            e.origin !== "https://tickets.avfc.co.uk" &&
            e.origin !== "https://ssopreview.gc.avfcservices.co.uk" &&
            e.origin !== "http://localhost:8080"
          ) {
            return;
          }

          // Intercept error page (currently the only way we have of guessing that the link has been made)
          if (
            e.data.screen === "errors.aspx" &&
            e.data.EventName === "load" &&
            vm.linkInProgress === false
          ) {
            vm.linkInProgress = true;
            vm.showIframe = false;
            vm.showLoadingBar = true;

            // Cover up the fact we are reloading iframes with a pretty loading bar
            var start1 = new Date();
            var end1 = new Date();
            end1.setSeconds(end1.getSeconds() + vm.loadingBarSeconds);

            vm.setUpProgressBar(
              "#loadBar",
              start1.getTime(),
              end1.getTime(),
              100
            );
            vm.loadIframe();
            vm.waitThenGetDetails();
          }
        }
      },
      false
    );
  },
  created() {},
  methods: {
    waitThenGetDetails() {
      setTimeout(() => this.getUpdatedDetails(), this.loadingBarSeconds * 1000);
    },
    getUpdatedDetails() {
      this.$refreshSession();
      this.$getCurrentUserAttributes().subscribe((userData) => {
        this.given_name = userData["given_name"];

        if (userData["custom:client_ref_verified"] === "true") {
          this.client_ref_no = userData["custom:client_ref_no"];
          this.showIframe = false;
          this.renderIframe = false;
          this.$emit("link-update", "complete");
        } else {
          // only show iframe here if we are not showing the loading bar
          if (this.showLoadingBar === false) {
            this.showIframe = true;
          }

          this.loadIframe();
        }
      });
    },
    loadIframe() {
      document.getElementById("ticketingIFrame").src =
        "https://tickets.avfc.co.uk/LinkCustomer.aspx"; //?rand=' + Math.round(Math.random() * 10000000);
    },
    setUpProgressBar(selector, startTime, endTime, update) {
      var timer;
      var elem = document.querySelector(selector);
      var iconElem = document.querySelector("#iconToShow");
      var max = endTime - startTime;
      elem.max = max;
      let iconCount = 0;

      var vm = this;
      var setValue = function () {
        var currentTime = new Date().getTime();
        var ellasped = currentTime - startTime;

        if (ellasped >= max) {
          ellasped = max;
          window.clearTimeout(timer);
        }
        elem.value = ellasped;
        var perc = (ellasped / max) * 100;

        switch (true) {
          case perc.toFixed(0) < 15:
            iconCount = 0;
            break;
          case perc.toFixed(0) < 30:
            iconCount = 1;
            break;
          case perc.toFixed(0) < 45:
            iconCount = 2;
            break;
          case perc.toFixed(0) < 60:
            iconCount = 3;
            break;
          case perc.toFixed(0) < 75:
            iconCount = 4;
            break;
          case perc.toFixed(0) < 90:
            iconCount = 5;
            break;
          case perc.toFixed(0) < 99:
            iconCount = 6;
            break;
          case perc.toFixed(0) <= 100:
            vm.showLoadingBar = false;
            break;
        }

        iconElem.setAttribute(
          "class",
          "features__item features__item--" +
            vm.loadingIconArray[iconCount].icon
        );
        iconElem.innerHTML = vm.loadingIconArray[iconCount].title;

        elem.setAttribute("data-label", perc.toFixed(0) + "%");
      };

      setValue();
      timer = window.setInterval(setValue, update);
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
.loadingIcon {
  margin-left: 200px;
  margin-top: 50px;
}
progress {
  text-align: center;
  height: 2.5em;
  width: 100%;
  -webkit-appearance: none;
  border: none;
  position: relative;
  color: #73a2dc;
  align-self: center;
}
progress:before {
  content: attr(data-label);
  font-size: 1.8em;
  vertical-align: 0;
  position: absolute;
  left: 0;
  right: 0;
}
progress[value]::-webkit-progress-bar {
  background-color: rgb(231, 245, 244);
  border-radius: 2px;
  box-shadow: 0 2px 5px rgba(224, 226, 226, 0.658) inset;
}
progress[value]::-webkit-progress-value {
  background-image: -webkit-linear-gradient(
      -45deg,
      transparent 33%,
      rgba(0, 0, 0, 0.1) 33%,
      rgba(0, 0, 0, 0.1) 66%,
      transparent 66%
    ),
    -webkit-linear-gradient(top, rgba(255, 255, 255, 0.25), rgba(0, 0, 0, 0.25)),
    -webkit-linear-gradient(left, #73a2dc, #660033);

  border-radius: 2px;
  background-size: 35px 20px, 100% 100%, 100% 100%;
}

.features {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  margin: 40px auto 0;
  padding: 0;
  max-width: 1200px;
  list-style: none;

  &__item {
    flex-grow: 1;
    flex-basis: 0;
    margin: 0 10px 30px;
    font-size: 15px;
    font-style: normal;
    font-weight: normal;
    line-height: 1.47;
    text-align: center;
    white-space: nowrap;

    span {
      display: block;
    }

    &:before {
      content: "";
      display: block;
      margin: 0 auto 10px;
      height: 97px;
      width: 97px;
      background-color: rgba(255, 255, 255, 0.75);
      background-position: 50%;
      background-repeat: no-repeat;
      border: 2px solid #fff;
      border-radius: 50%;
    }

    &--villatv:before {
      background-image: url("../assets/sso-icon-set/villatv.png");
      background-size: 64px;
      background-position: 50% 45%;
    }

    &--sso-app:before {
      background-image: url("../assets/sso-icon-set/sso-app.svg");
      background-size: 64px;
      background-position: 50% 45%;
    }

    &--sso-auction-site:before {
      background-image: url("../assets/sso-icon-set/sso-auction-site.svg");
      background-size: 48px;
      background-position: 50% 50%;
    }
    &--sso-club-site:before {
      background-image: url("../assets/sso-icon-set/sso-club-site.svg");
      background-size: 64px;
      background-position: 50% 45%;
    }

    &--sso-click-collect:before {
      background-image: url("../assets/sso-icon-set/sso-click-collect.svg");
      background-size: 48px;
      background-position: 50% 50%;
    }
    &--sso-memberships:before {
      background-image: url("../assets/sso-icon-set/sso-memberships.svg");
      background-size: 64px;
      background-position: 50% 45%;
    }

    &--sso-rewards:before {
      background-image: url("../assets/sso-icon-set/sso-rewards.svg");
      background-size: 48px;
      background-position: 50% 50%;
    }
    &--sso-ticketing:before {
      background-image: url("../assets/sso-icon-set/sso-ticketing.svg");
      background-size: 64px;
      background-position: 50% 45%;
    }

    &--sso-official-store:before {
      background-image: url("../assets/sso-icon-set/sso-official-store.svg");
      background-size: 48px;
      background-position: 50% 50%;
    }
  }
}
</style>